import { Button, Form, Input, message, Modal, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { resetUserLoginApi, UserLoginApi } from '../../../../redux/features/auth/UserLogin';
import { encryptInput } from '../../../../shared/shared-functions';
import './login.css';
import config from '../../../../util/config';
import { easeInOut, motion } from 'framer-motion';
import WaveAnimation from '../../../child-components/wave-animation/waveAnimation';
import { validatePassword } from '../../../../common/commonfunctions';
import { RiContactsLine, RiLockPasswordLine } from 'react-icons/ri';
import { Typewriter } from 'react-simple-typewriter';
import { useLogType } from '../../../../context/LogTypeContext';
import axios from 'axios';
import VerifyOTP from '../verify-otp/verifyOtp';
import { ForgotPasswordApi, resetForgotPassword } from '../../../../redux/features/auth/ForgotPassword';

function LoginPage() {
	const { userLoginApiRes, userLoginApiLoad } = useSelector((state: any) => state?.userLoginApi);
	const	{ forgotPassRes, forgotPassLoad } = useSelector((state: any) => state.forgotPassword);

	const token = forgotPassRes?.data?.accessToken;
	const [userName, setUserName] = useState();

	const { logtype, setLogtype ,isResendOtp, setIsResendOtp,isVerifyModalVisible, setIsVerifyModalVisible} = useLogType();

	useEffect(() => {
		if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 200) {
			setIsVerifyModalVisible(true);
			if(isResendOtp){
				message.success('OTP resent successfully!');
			}else{
				message.success('OTP sent successfully!');
			}
		} else if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 400) {
			message.warning(forgotPassRes?.message);
			dispatch(resetForgotPassword());
		} else if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 500) {
			message.error(forgotPassRes?.message);
			dispatch(resetForgotPassword());
		}
	}, [forgotPassRes, forgotPassLoad]);

	const navigate = useNavigate(),
		dispatch = useDispatch();
      // Old one
		// const onFinish = (values: any) => {
		// 	const { username, password, phonenumber } = values;
		// 	const encryptedPwd:any = encryptInput(password);
		// 	try {
		// 		if ((username || phonenumber) && password) {
		// 			const randomDeviceId = Math?.floor(Math?.random() * 1000000)?.toString(); 
		// 			const userLoginMdl:any = {
		// 				Password: encryptedPwd,
		// 				DeviceId: randomDeviceId,
		// 				UserType:''
		// 			};
		// 			if (username) {
		// 				userLoginMdl.UserName = username;
		// 				userLoginMdl.UserType='SystemUser'
		// 			  } else if (phonenumber) {
		// 				userLoginMdl.PhoneNumber = phonenumber;
		// 				userLoginMdl.UserType='Influencer'
		// 			dispatch(UserLoginApi(userLoginMdl));
		// 		} else {
		// 			message.error('Failed to login user.');
		// 			return;
		// 		}
		// 	} catch (error: any) {
		// 		message.error(error.message);
		// 		return;
		// 	}
		// };

	//#region  functions start
	const onFinish = (values: any) => {
		const { username, password, phonenumber } = values;
		let encryptedPwd:any ;
		if(password){
			encryptedPwd = encryptInput(password);
		}
		try {
			if ((username) && password) {
				const randomDeviceId = Math?.floor(Math?.random() * 1000000)?.toString(); 
				const userLoginMdl:any = {
					Password: encryptedPwd,
					DeviceId: randomDeviceId,
					UserType:''
				};
				if (username) {
					userLoginMdl.UserName = username;
					userLoginMdl.UserType='SystemUser'
				  }
				dispatch(UserLoginApi(userLoginMdl));
			} else if (phonenumber) {
				// userLoginMdl.PhoneNumber = phonenumber;
				// userLoginMdl.UserType='Influencer'
				// setIsVerifyModalVisible(true);

				const formData = new URLSearchParams();
				formData.append('PhoneNumber', phonenumber);
				formData.append('UserType', 'Influencer');
				setUserName(phonenumber)
			   dispatch(ForgotPasswordApi({ input: formData }));
			  }
		} catch (error: any) {
			message.error(error.message);
			return;
		}
	};

	//#endregion functions end
	useEffect(() => {
		sessionStorage.clear();
	}, []);

   // working code for 24 hrs after check uncooment the code 
	const setWithExpiryEOD = (key: any, value: any) => {
		const now = new Date();
		const endOfDay = new Date(now);
		endOfDay.setHours(23, 59, 59, 999); // Set to the last millisecond of the day
		const expiryTime = endOfDay.getTime();
		// const expiryTime = now.getTime() + 10 * 60 * 1000;
		const item = { value, expiryTime };
		// const item = { value, expiryTime };
		localStorage.setItem(key, JSON.stringify(item));
	};

	// working code for 1 minute after check comment the code 
	// const setWithExpiryEOD = (key: any, value: any) => {
	// 	const now = new Date();
	// 	const expiryTime = now.getTime() + 1 * 60 * 1000; // 1 minute = 60,000 ms
	// 	const item = { value, expiryTime };
	// 	localStorage.setItem(key, JSON.stringify(item));
	// };

	//#region use effect start
	useEffect(() => {
		getLabel();
		switch (userLoginApiRes?.DATA?.[0]?.STATUSCODE) {
			case 200:
				setWithExpiryEOD("authUser", userLoginApiRes?.DATA?.[0])
				// sessionStorage.setItem('accessToken', userLoginApiRes?.DATA?.[0]?.AUTHTOKEN);
				// sessionStorage.setItem('refreshToken', 'D5B17F74-BD9C-4FD3-9AEE-3B9B9254DF88');

				navigate('/home');
				dispatch(resetUserLoginApi());
				break;
			case 400:
				// message.warning("Invalid credentials.");
				message.warning(userLoginApiRes?.DATA[0]?.MSG);
				dispatch(resetUserLoginApi());
				break;
			case 500:
				message.error(userLoginApiRes.message);
				dispatch(resetUserLoginApi());
				break;
			default:
				break;
		}
	}, [userLoginApiRes, userLoginApiLoad]);

	//#endregion use effect end	

	const LoginToggle = (typeofLog: any) => {
		setLogtype(typeofLog)
	}

	const changeIsVerifyMdlOpen = (boolVal: boolean) => {
		setIsVerifyModalVisible(boolVal);
		dispatch(resetForgotPassword());
	};

	const resendOtpToggle = (boolVal: boolean) => {
		setIsResendOtp(boolVal);
	};

	//state for set InfluencerLoginUser data
	const [influencerLoginUser, setInfluencerLoginUser] = useState("")
	const [isForgotPasswordShow, setIsForgotPasswordShow] = useState("")

	//funtion for get InfluencerLoginUser data
	const getLabel = async () => {
		const res = await axios.get("/Configuration.json")
		setInfluencerLoginUser(res.data.IsLoginInfluencerShow);
		setIsForgotPasswordShow(res.data.IsForgotPasswordShow)
	}

	return (
		<div className="parent">
			<motion.div initial={{ y: 400, opacity: 0.5 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1, ease: easeInOut }}>
				<div className="loginMaindiv">
					{/* <img src="/assets/images/3dpie.png" className="todo3d " alt="" /> */}
					{/* <img src="/assets/images/robot.png"  className="pieimgmotion " alt="" /> */}

					<div className="loginCard">
						<div className="loginCardLeft">
							<img src="/assets/images/plogo.png" className="todo3d " alt="" />

							{/* <p className="">USER LOGIN</p> */}
							<div className='gx-d-flex gx-align-items-center gx-justify-content-between' style={{ width: "100%" }}>
								<img src="/assets/images/logo.png" alt="" width={70} className='gx-mb-3 gx-ml-5' />
								{influencerLoginUser && (
									logtype === 'Influencer' ? (
										<Tag
											color="black"
											className="gx-fs-sm gx-mr-4 cursor-pointer"
											onClick={() => LoginToggle("SystemUser")}
										>
											Login as User?
										</Tag>
									) : (
										<Tag
											color="black"
											className="gx-fs-sm gx-mr-4 cursor-pointer"
											onClick={() => LoginToggle("Influencer")}
										>
											Login as Influencer?
										</Tag>
									)
								)}
							</div>

							<Form name="loginForm" onFinish={onFinish} layout="vertical" className="login-form">

								{logtype === 'SystemUser' ?
									<motion.div initial={{ x: 200, opacity: 0.2 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1, ease: easeInOut }}>

										<Form.Item label="User Name" name="username" rules={[{ required: true, message: 'Please enter user name' }]}>
											<Input placeholder="Enter your username" prefix={<RiContactsLine />} size="large" maxLength={250} />
										</Form.Item>
									</motion.div>
									:
									<Form.Item label="Phone number" name="phonenumber"
										rules={[
											{
												required: true,
												message: 'Please enter Phone Number'
											},
											{
												pattern: /^[0-9]{10,12}$/,
												message: 'Phone number must be 10-12 digits'

											}
										]}
									>
										<Input placeholder="Enter your Phone Number" prefix={<RiContactsLine />} size="large" maxLength={250} />
									</Form.Item>
								}

                        {logtype === 'SystemUser' && <> <Form.Item label="Password" name="password" rules={[{ validator: validatePassword }]} className="gx-p-0 gx-m-0">
                           <Input.Password placeholder="Enter your password" prefix={<RiLockPasswordLine />} size="large" maxLength={250} />
                        </Form.Item> </>}
								

								{/* <p className="gx-fs-sm gx-p-0 gx-m-0 gx-link" onClick={showForgotMdl}> */}
								{/* <p className="gx-fs-sm gx-p-0 gx-m-0 gx-link">
									Forgot password?
								</p> */}
								{isForgotPasswordShow && logtype === 'SystemUser' &&  (
								<Link
									to="/forgot-password"
									className="site-button-link forget-pass  float-right custom-forgot-pwd-style"
									style={{ marginTop: '8px', fontFamily: 'NoirPro' }}
								>
									Forgot Password?
								</Link>
 								)}


								<Form.Item>
									<Button htmlType="submit" className="login-btn gx-mt-3" loading={userLoginApiLoad} style={{ backgroundColor: "black !important", color: "white !important" }}>
										Login
									</Button>
								</Form.Item>
							</Form>
							{/* <p style={{ marginTop: '3px', width: '200px' }} className="loginFormCopyright gx-fs-sm">
								{config?.footerText}
							</p> */}
						</div>

						<div className="loginCardRight" style={{ position: 'relative' }}>
							<div className="moving-bubble"></div>
							<div style={{ position: 'absolute', top: '40px', borderRadius: '10px' }}>
								<img src="/assets/images/ailogo.svg" style={{ borderRadius: '10px' }} alt="" className="" width={150} />
								<p className=" gx-fs-xl gx-m-0 gx-p-0"> Chatbot</p>
								{/* <p className=" gx-fs-xl gx-m-0 gx-p-0">Artificial Intelligence </p> */}
								{/* <p className=" gx-m-0 gx-p-0 gx-fs-sm">Artificial Intelligence</p> */}
								<div style={{ color: "green" }}>
									<Typewriter
										words={['Artificial Intelligence']}
										typeSpeed={70}
										cursor={true}
										loop={true}
									/>
								</div>
							</div>
							<WaveAnimation />
						</div>
					</div>
				</div>
			</motion.div>

			{isVerifyModalVisible && <VerifyOTP userName={userName} accessToken={token} disMdl={true} trigger={changeIsVerifyMdlOpen} resendOtpToggle={resendOtpToggle} />}
		</div>
	);
}

export default LoginPage;
